'use client';

import { AlertTriangle, X } from 'lucide-react';

interface FormErrorBannerProps {
  message: string;
  onDismiss?: () => void;
}

export default function FormErrorBanner({ message, onDismiss }: FormErrorBannerProps) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="flex items-start gap-3 px-4 py-3.5 rounded-xl bg-red-50 border border-red-200 text-red-800 animate-slide-down"
    >
      <AlertTriangle className="w-4.5 h-4.5 flex-shrink-0 mt-0.5 text-red-500" aria-hidden="true" />
      <p className="flex-1 text-sm font-500 leading-relaxed">{message}</p>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="flex-shrink-0 text-red-400 hover:text-red-600 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-red-400 rounded-md p-0.5"
          aria-label="Dismiss error"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}